import CustomerSearchValue   from "../../../domain/customer/criteria/CustomerSearchValue";
import CustomerId            from "../../../domain/customer/CustomerId";
import CustomerIds           from "../../../domain/customer/CustomerIds";
import CustomerRepository    from "../../../domain/customer/CustomerRepository";
import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import MailGroupRepository   from "../../../domain/mail/group/MailGroupRepository";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import CustomerDataSource    from "../../../infrastructure/datasource/customer/CustomerDataSource";
import MailGroupDataSource   from "../../../infrastructure/datasource/mail/group/MailGroupDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";

class GetCustomersAllHaveEmail {
  private readonly customerRepository: CustomerRepository = new CustomerDataSource(this.dispatch);
  private readonly mailGroupRepository: MailGroupRepository = new MailGroupDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);

  constructor(
    private readonly dispatch,
  ) {
  }

  public async execute(search: CustomerSearchValue) {
    this.fetchStatusRepository.start();
    try {
      const response = await this.customerRepository.findAllHaveEmail(search);
      const list: CustomerId[] = response.data.customers.map(customer => new CustomerId(customer.id));
      this.mailGroupRepository.allSelectedCustomer(new CustomerIds(list))
    } catch (e) {
      this.notifyRepository.fetchFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetCustomersAllHaveEmail;
